<template>
	<div class="detailsHeader">
    <span class="detailsHeader-goback"></span>
		<span><span class="icon-closed" @click= "goBack()"></span></span>
		<div class="details-title">
			商品详情
		</div>
		<span class="icon-cart-group">
			<span class="icon-cart" @click="goShopCart">{{counter}}</span>
		</span>
	</div>
</template>
<script>
	import { mapState } from 'vuex'
	export default {
    props: ['path'],
		data(){
			return {

			}
		},
		computed: mapState({
		    counter: state => state.shopCart.counter,
		    title: state => state.proDetails.title
  		}),
  		methods: {
	        goBack () {
	           if (this.path === undefined) {
	             this.$router.push('/')
	           } else {
	             this.$router.push(this.path)
	           }

	        },
	  		goShopCart(){
				this.$router.push({ 
						name:'productShoppingCart',
						query: { 
							'isProCart': true
					}
				});
  			}
  		},
  		mounted(){
  			this.$store.dispatch('getCartNum');
  		}

	}
</script>

<style lang="scss">
		
	@import '../../../assets/css/mixin';

	.detailsHeader {
		padding: 0 pxToRem(30px);
    position: relative;
		display: flex;
		justify-content: space-between;
		height: pxToRem(100px);
		line-height: pxToRem(100px);
		background-color: #fff;
		opacity: .9;

		.vt-middle {
			display: inline-block;
			padding: 0 10%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellpsis;
			width: 1px;
		}
	}
	.details-title {
		padding: 0 10%;
		overflow: hidden;
    	white-space: nowrap;
    	text-overflow: ellipsis;
	}
	.icon-cart-group {
		display: flex;
		align-items: center;
		.icon-cart {
			text-align: center;
		    line-height: pxToRem(40px);
		    color: #666;
		    font-size: pxToRem(20px);
		}
	}

  .detailsHeader-goback {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: pxToRem(80px);
    background-color: transparent;
  }
</style>


// WEBPACK FOOTER //
// proDetailHeader.vue?03174d8c